export default {
  guardiao_protetor: [
    {
      name: 'Escudo Pequeno de Madeira',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Escudo Pequeno de Madeira',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Escudo Pequeno de Pedra',
      desc: '1d6',
      range: 1
    },

    {
      name: 'Escudo Médio de Metal',
      desc: '1d6 + 1',
      range: 1
    },

    {
      name: 'Escudo Gigante de Aço',
      desc: '1d8 + 2',
      range: 1,
      agi: -1
    },

    {
      name: 'Escudo Torre Inabalável',
      desc: '1d10 + 2',
      range: 1,
      pv: 10
    }
  ],

  ninja: [
    {
      name: 'Espada Comum',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Espada Comum',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Kunai de Aço Negro',
      desc: '1d6',
      range: 2
    },

    {
      name: 'Katana',
      desc: '1d6 + 1',
      range: 1
    },

    {
      name: 'Shuriken Gigante',
      desc: '1d6 + 2',
      range: 2
    },

    {
      name: 'Streek, a Kunai Fantasma',
      desc: '1d8 + 2',
      range: 2,
      effect:
        'Joga 1d6, se o resultado for 6, diminui a Defesa do alvo pela metade arredondado para baixo.'
    }
  ],

  necromante: [
    {
      name: 'Grimório Comum',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Grimório Comum',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Grimório Vermelho Escarlate',
      desc: '1d6',
      range: 1
    },

    {
      name: 'Grimório Negro',
      desc: '1d6 + 1',
      range: 1
    },

    {
      name: 'Grimório dos Mortos',
      desc: '1d8 + 1',
      range: 2
    },

    {
      name: 'Grimório do Submundo',
      desc: '1d10 + 2',
      range: 2
    }
  ],

  alquimista: [
    {
      name: 'Estilingue de Metal',
      desc: '1d4',
      range: 2
    },

    {
      name: 'Estilingue de Metal',
      desc: '1d4',
      range: 2
    },

    {
      name: 'Funda Média de Borracha',
      desc: '1d6',
      range: 2
    },

    {
      name: 'Pistola "Versão Alfa"',
      desc: '1d6 + 1',
      range: 3
    },

    {
      name: 'Zarabatana com Mira',
      desc: '1d8 + 1',
      range: 3
    },

    {
      name: 'Pistola Semi-Automática de Aço',
      desc: '1d10 + 2',
      range: 2,
      ph: 2
    }
  ],

  monge: [
    {
      name: 'Luvas de Couro',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Luvas de Couro',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Bastão de Luta',
      desc: '1d6',
      range: 1
    },

    {
      name: 'Garras de Aço',
      desc: '1d6 + 1',
      range: 1
    },

    {
      name: 'Bastão de Titanium',
      desc: '1d8 + 1',
      range: 2
    },

    {
      name: 'Nunchaku dos Dragões',
      desc: '1d10 + 2',
      range: 2,
      pv: 10
    }
  ],

  ladino: [
    {
      name: 'Adaga Simples',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Adaga Simples',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Besta de Mão',
      desc: '1d6',
      range: 2
    },

    {
      name: 'Katar Simples',
      desc: '1d6 + 1',
      range: 1
    },

    {
      name: 'Arco de Madeira Branca',
      desc: '1d8 + 1',
      range: 2
    },

    {
      name: 'Adaga das Sombras',
      desc: '1d10 + 2',
      range: 1,
      mov: 1
    }
  ],

  bardo: [
    {
      name: 'Violão Comum',
      desc: '1d4',
      range: 2
    },

    {
      name: 'Violão Comum',
      desc: '1d4',
      range: 2
    },

    {
      name: 'Violino de Madeira Rupestre',
      desc: '1d6',
      range: 2
    },

    {
      name: 'Violão Erudita',
      desc: '1d6 + 1',
      range: 1
    },

    {
      name: 'Violino de Madeira Negra do Norte',
      desc: '1d8 + 1',
      range: 2
    },

    {
      name: 'Violão Gêmeo Aktha de Zynthier, o Bardo Mestre',
      desc: '1d10 + 2',
      range: 2,
      ph: 1
    }
  ],

  mestre_modelador: [
    {
      name: 'Cajado de Madeira',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Cajado de Madeira',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Cajado de Madeira Negra',
      desc: '1d6',
      range: 2
    },

    {
      name: 'Cajado de Pedra Roxa',
      desc: '1d6 + 1',
      range: 1
    },

    {
      name: 'Cajado de Pedra das Estrelas',
      desc: '1d8 + 1',
      range: 2
    },

    {
      name: 'Cajado do Centro do Universo',
      desc: '1d10 + 2',
      range: 2,
      ph: 1
    }
  ],

  barbaro: [
    {
      name: 'Machado Simples',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Machado Simples',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Machado de Batalha',
      desc: '1d6',
      range: 1
    },

    {
      name: 'Machado Duplo',
      desc: '1d8 + 1',
      range: 1
    },

    {
      name: 'Machado de Guerra',
      desc: '1d8 + 2',
      range: 2
    },

    {
      name: 'Machado Gigante da Fúria',
      desc: '1d12 + 2',
      range: 2,
      pv: -10,
      mov: -1,
      def: -1
    }
  ],

  mercenario: [
    {
      name: 'Adaga Simples',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Adaga Simples',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Katar Simples',
      desc: '1d6',
      range: 1
    },

    {
      name: 'Adaga de Arremesso',
      desc: '1d6 + 1',
      range: 2
    },

    {
      name: 'Adaga de Duas Lâminas',
      desc: '1d8 + 1',
      range: 1
    },

    {
      name: 'Katar Escondida da Morte',
      desc: '1d10 + 2',
      range: 1,
      ph: 1
    }
  ],

  mago: [
    {
      name: 'Bastão de Madeira',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Bastão de Madeira',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Cajado de Madeira Resistente',
      desc: '1d6',
      range: 1
    },

    {
      name: 'Cajado de Pedra',
      desc: '1d6 + 1',
      range: 1
    },

    {
      name: 'Cajado das Runas Mágicas',
      desc: '1d8 + 1',
      range: 2
    },

    {
      name: 'Cajado Elementar Erudita',
      desc: '1d8 + 2',
      range: 2,
      ph: 2
    }
  ],

  cacador: [
    {
      name: 'Arco Curto',
      desc: '1d4',
      range: 2
    },

    {
      name: 'Arco Curto',
      desc: '1d4',
      range: 2
    },

    {
      name: 'Besta Média',
      desc: '1d6',
      range: 2
    },

    {
      name: 'Arco de Caça',
      desc: '1d6 + 1',
      range: 3
    },

    {
      name: 'Besta Gigante de Caça',
      desc: '1d8 + 1',
      range: 2
    },

    {
      name: 'Arco de Chifre de Dragão',
      desc: '1d8 + 2',
      range: 3,
      mov: 1
    }
  ],

  guerreiro: [
    {
      name: 'Espada de Madeira',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Espada de Madeira',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Espada Normal',
      desc: '1d6',
      range: 1
    },

    {
      name: 'Espada Pesada',
      desc: '1d6 + 1',
      range: 1
    },

    {
      name: 'Espada de Duas Lâminas',
      desc: '1d8 + 2',
      range: 1
    },

    {
      name: 'Espada Gigante de Aço Negro',
      desc: '1d10 + 2',
      range: 2,
      pv: 5
    }
  ],

  arqueiro: [
    {
      name: 'Arco Curto',
      desc: '1d4',
      range: 2
    },

    {
      name: 'Arco Curto',
      desc: '1d4',
      range: 2
    },

    {
      name: 'Besta Pequena',
      desc: '1d6',
      range: 2
    },

    {
      name: 'Arco Longo',
      desc: '1d6 + 1',
      range: 2
    },

    {
      name: 'Besta Pesada de Combate',
      desc: '1d8 + 1',
      range: 3
    },

    {
      name: 'Arco Élfico Milenar',
      desc: '1d10 + 2',
      range: 3,
      def: 1
    }
  ],

  clerigo: [
    {
      name: 'Cajado de Madeira',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Cajado de Madeira',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Cajado Simples',
      desc: '1d6',
      range: 1
    },

    {
      name: 'Cajado de Onix',
      desc: '1d8 + 1',
      range: 1
    },

    {
      name: 'Cajado Milenar',
      desc: '1d8 + 1',
      range: 2
    },

    {
      name: 'Cajado dos Deuses',
      desc: '1d10 + 2',
      range: 1,
      pv: 5,
      ph: 1
    }
  ],

  juiz: [
    {
      name: 'Chicote Simples',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Chicote Simples',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Chicote de Espinhos',
      desc: '1d6',
      range: 1
    },

    {
      name: 'Chicote de Ossos',
      desc: '1d6 + 1',
      range: 1
    },

    {
      name: 'Chicote de Marfim',
      desc: '1d8 + 1',
      range: 1
    },

    {
      name: 'Chicote da Punição Divina',
      desc: '1d10 + 2',
      range: 1,
      pv: 5
    }
  ],

  general: [
    {
      name: 'Espada Longa',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Espada Longa',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Zanbatou de Lâmina Quebrada',
      desc: '1d6',
      range: 1
    },

    {
      name: 'Zanbatou Simples',
      desc: '1d6 + 1',
      range: 2
    },

    {
      name: 'Zanbatou de Aço Brilhante',
      desc: '1d8 + 1',
      range: 2
    },

    {
      name: 'Lendária Zanbatou dos Gigantes',
      desc: '1d10 + 2',
      range: 2,
      pv: 5
    }
  ],

  assassino: [
    {
      name: 'Adaga Escondida',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Adaga Escondida',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Foice Pequena',
      desc: '1d6',
      range: 1
    },

    {
      name: 'Foice Normal',
      desc: '1d8 + 1',
      range: 1
    },

    {
      name: 'Foice Gigante',
      desc: '1d10 + 1',
      range: 1
    },

    {
      name: 'Foice do Templo de Esthuwl',
      desc: '2d6 + 1',
      range: 1,
      ph: 1
    }
  ],

  xama: [
    {
      name: 'Pergaminho Rasgado',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Pergaminho Rasgado',
      desc: '1d4',
      range: 1
    },

    {
      name: 'Pergaminho Velho',
      desc: '1d6',
      range: 1
    },

    {
      name: 'Pergaminho Roxo',
      desc: '1d6 + 1',
      range: 1
    },

    {
      name: 'Pergaminho Histórico Milenar',
      desc: '1d8 + 1',
      range: 1
    },

    {
      name: 'Pergaminho dos Montes de Lyrueh',
      desc: '1d10 + 2',
      range: 1,
      pv: 5
    }
  ],

  mimico: []
}
